"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthProviderImpl = void 0;
var FirebaseAuth_1 = require("../../firebase/FirebaseAuth");
var Utils_1 = require("../../../utils/Utils");
var CacheManager_1 = require("../../CacheManager");
var AuthProviderImpl = (function () {
    function AuthProviderImpl(cfg) {
        var _this = this;
        this.cfg = cfg;
        this.log = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.cfg.debuggable) {
                (_a = _this.cfg.logger).log.apply(_a, __spreadArray(["[".concat(_this.env, "] ").concat((0, Utils_1.getTimeString)(), " ").concat(AuthProviderImpl.TAG, "#")], args, false));
            }
        };
        this.signIn = function (email, password) {
            return _this.firebaseAuth.signIn(email, password);
        };
        this.loginDemoPage = function () {
            return _this.firebaseAuth.loginDemoPage();
        };
        this.signOut = function () {
            (0, CacheManager_1.cacheClear)();
            return _this.firebaseAuth.signOut();
        };
        this.signUp = function (email, password) {
            return _this.firebaseAuth.signUp(email, password);
        };
        this.sendVerifiedEmail = function (email, psw) {
            return _this.firebaseAuth.sendVerifiedEmail(email, psw);
        };
        this.resendVerifiedEmail = function (email) {
            return _this.firebaseAuth.resendVerifiedEmail(email);
        };
        this.resetPassword = function (authCode, newPassword) {
            return _this.firebaseAuth.confirmPasswordReset(authCode, newPassword);
        };
        this.sendEmailVerification = function (email) {
            return _this.firebaseAuth.sendSignInLink(email);
        };
        this.log('created#');
        this.firebaseAuth = new FirebaseAuth_1.FirebaseAuth(cfg);
    }
    AuthProviderImpl.prototype.init = function (env, cfg) {
        this.env = env;
        if (cfg) {
            this.cfg = cfg;
        }
        this.log('init# env:', env);
        return this.firebaseAuth.init(env);
    };
    AuthProviderImpl.prototype.setDebuggable = function (debuggable) {
        if (this.cfg) {
            this.cfg.debuggable = debuggable;
        }
    };
    AuthProviderImpl.prototype.getUser = function () {
        this.log('getUser');
        var user = this.firebaseAuth.getUser();
        this.log('getUser', user);
        return user;
    };
    AuthProviderImpl.prototype.sendResetPassword = function (email) {
        return this.firebaseAuth.sendPasswordReset(email);
    };
    AuthProviderImpl.prototype.signInWithGoogle = function () {
        return this.firebaseAuth.signInWithGoogle();
    };
    AuthProviderImpl.prototype.signInWithFB = function () {
        return this.firebaseAuth.signInWithFB();
    };
    AuthProviderImpl.prototype.updatePassword = function (newPassword) {
        return this.firebaseAuth.updatePassword(newPassword);
    };
    AuthProviderImpl.prototype.updateProfile = function (displayName, photoUrl) {
        return Promise.resolve();
    };
    AuthProviderImpl.prototype.uploadPhotoAsAvatar = function (file) {
        return Promise.resolve("https://lh5.googleusercontent.com/-ZDjTW6LDn6Y/AAAAAAAAAAI/AAAAAAAAjDc/cMF3Veygbm0/photo.jpg");
    };
    AuthProviderImpl.prototype.setConnectionListener = function (listener) {
        this.firebaseAuth.observeAuthState(listener);
    };
    AuthProviderImpl.prototype.stopAllMonitor = function () {
    };
    AuthProviderImpl.TAG = 'AuthProvider';
    return AuthProviderImpl;
}());
exports.AuthProviderImpl = AuthProviderImpl;
//# sourceMappingURL=AuthProviderImpl.js.map